<template>
  <VPopupWidget
    :name="$t('labels.saveFilter')"
    btn-depressed
    :nudge-width="250"
    :visible="menu"
    :set-expand="
      (v) => {
        menu = v
      }
    "
    bottom
    left
  >
    <template v-slot:content>
      <v-text-field
        v-model="filterName"
        :placeholder="$t(`labels.name`)"
        :hint="$t('labels.saveFilterAs')"
        persistent-hint
        clearable
      />
    </template>
    <template v-slot:title>{{ $t('labels.saveFilter') }}</template>
    <template slot="footer-actions">
      <v-btn depressed @click="doSave" :loading="loading">{{ $t('labels.save') }}</v-btn>
    </template>
  </VPopupWidget>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { NAMESPACE } from '@argon/app/store'
import { VPopupWidget, BaseForm, FormErrors } from '@argon/app/components'

export default {
  name: 'SearchSaver',
  extends: BaseForm,
  components: { VPopupWidget },
  props: {
    context: { type: String, required: true }
  },
  data: () => ({
    menu: false,
    filterName: null,
    loading: false,
    filterObject: null
  }),
  methods: {
    ...mapActions(NAMESPACE, ['saveAppliedFilter']),
    doSave() {
      this.loading = true
      this.saveAppliedFilter({ context: this.context, name: this.filterName }).then(() => {
        this.filterName = null
        this.loading = false
        this.menu = false
      })
    }
  }
}
</script>
